import React from "react";

export default function WeatherMonitorSupport() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Weather Monitor App – Support</h1>

      <p className="mb-6">
        Welcome to the <strong>Weather Monitor Support Center</strong>.  
        We’re here to help you get the most out of the app and answer any questions you may have.
      </p>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">📧 Contact Us</h2>
        <p>
          If you need assistance, please reach out:
          <br />
          <strong>Email:</strong>{" "}
          <a
            href="mailto:pauversil@devadedoyin.co.uk"
            className="text-blue-600 underline"
          >
            pauversil@devadedoyin.co.uk
          </a>
          <br />
          <strong>Response Time:</strong> We aim to respond within 24–48 hours.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">❓ Frequently Asked Questions (FAQ)</h2>
        <div className="mb-4">
          <p className="font-semibold">Q: How do I change the location for weather updates?</p>
          <p>A: Go to <em>Settings &gt; Location</em> and select your preferred city or allow location services.</p>
        </div>
        <div className="mb-4">
          <p className="font-semibold">Q: Why am I not receiving daily weather updates?</p>
          <p>A: Please make sure notifications are enabled in both your phone settings and the app’s settings.</p>
        </div>
        <div className="mb-4">
          <p className="font-semibold">Q: The app shows inaccurate weather data. What should I do?</p>
          <p>A: Try refreshing the app or checking your internet connection. If the issue continues, contact support.</p>
        </div>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">🔒 Privacy & Legal</h2>
        <ul className="list-disc pl-5">
          <li>
            <a
              href=""
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              href=""
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">ℹ️ About Weather Monitor</h2>
        <p>
          Weather Monitor gives you <strong>daily, hourly, and weekly forecasts</strong> with alerts for rain,
          storms, and temperature changes so you can plan your day with confidence.
        </p>
      </section>
    </div>
  );
}
